import React, { createContext } from 'react';

export const AvaliableRuralContext = createContext({});

export function AvaliableRuralProvider({ children }) {
  const [showAvaliableRuralCandidate, setShowAvaliableRuralCandidate] =
    React.useState(false);

  const [dataToAvaliationRural, setDataToAvaliationRural] = React.useState();

  const handleCHabgeShowAvaliableRural = React.useCallback((value) => {
    setShowAvaliableRuralCandidate(value);
  }, []);

  const handleCHabgeDataAvaliation = React.useCallback((value) => {
    setDataToAvaliationRural(value);
  }, []);

  return (
    <AvaliableRuralContext.Provider
      value={{
        showAvaliableRuralCandidate,
        setShowAvaliableRuralCandidate,
        dataToAvaliationRural,
        setDataToAvaliationRural,
        handleCHabgeShowAvaliableRural,
        handleCHabgeDataAvaliation,
      }}
    >
      {children}
    </AvaliableRuralContext.Provider>
  );
}
